import React from "react";
import { notify } from "@/shared/utils/notify";
import { combo3x2ProductsService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const useCreateProduct3x2 = ({setOpenModalCreate, rule_id}: {setOpenModalCreate: (val: boolean) => void, rule_id:number}) => {
  const [loading, setLoagding] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        product_id: yup.string().required('Campo requerido'),
      }),
    )
  });

  const handleSubmit = onSubmit(async (data:any) => {
    
    if (loading) return
    
    setLoagding(true)
    await combo3x2ProductsService
      .create({product_id: +data.product_id, rules_3_x_2_id: rule_id })
      .then((_res: any) => {
        notify.success(`Se ha creado la salsa ${data.name} exitosamente`);
        setOpenModalCreate(false)
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      }).finally(()=>{
        setLoagding(false)
      })
  }  )

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
